import Enfinity from "@/assets/images/enfinity.png";
import Amazon from "@/assets/svg/amazon.svg";
import Facebook from "@/assets/svg/facebook.svg";
import Google from "@/assets/svg/google.svg";
import Kuaishou from "@/assets/svg/kuaishou.svg";
import Microsoft from "@/assets/svg/microsoft.svg";
import Shorts from "@/assets/svg/shorts.svg";
import Snapchat from "@/assets/svg/snapchat.svg";
import Tiktok from "@/assets/svg/tiktok.svg";
import Twitch from "@/assets/svg/twitch.svg";
import YouTube from "@/assets/svg/yt.svg";
import Instagram from "@/assets/svg/instagram.svg";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

export default function Platforms() {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;

  const platforms = [
    { name: "microsoft", icon: Microsoft },
    { name: "youtube", icon: YouTube },
    { name: "google", icon: Google },
    { name: "facebook", icon: Facebook },
    { name: "tiktok", icon: Tiktok },
    { name: "snapchat", icon: Snapchat },
  ];

  const shieldPlatforms1 = [
    { name: "facebook", icon: Facebook },
    { name: "shorts", icon: Shorts },
    { name: "amazon", icon: Amazon },
    { name: "instagram", icon: Instagram },
  ];

  const shieldPlatforms2 = [
    { name: "tiktok", icon: Tiktok },
    { name: "twitch", icon: Twitch },
    { name: "kuaishou", icon: Kuaishou },
    { name: "youtube", icon: YouTube },
  ];

  return (
    <div
      id="partner-platforms"
      className="flex flex-col justify-center items-center relative overflow-hidden rounded-[20px] animate-slide-up will-change-transform pt-24 lg:pt-36 pb-2 5xl:max-w-[100rem] 5xl:mx-auto bg-white"
    >
      <style>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
      <style>{`
        @keyframes scroll-right {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(50%);
          }
        }
      `}</style>
      <style>{`
        .scroll-inner {
          position: relative;
          width: 100%;
          overflow: hidden;
          height: 6rem;
        }

        .scroll-wrapper {
          position: absolute;
          display: flex;
        }

        .scroll-section {
          display: flex;
          animation: swipe var(--speed) linear infinite;
        }

        @keyframes swipe {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      <div className="text-center space-y-4">
        <p className="text-[#FF6B35] font-semibold text-lg md:text-xl uppercase tracking-wide">
          SUITABLE FOR
        </p>
        <h2 className="leading-tight text-5xl lg:text-6xl font-semibold text-black">
          All Major Platforms
        </h2>
        <p className="text-lg md:text-xl text-black max-w-xs lg:max-w-3xl mx-auto pb-14">
          From solo creators to major media networks, EnfiniShield ensures you
          protect your content and reclaim the royalties you deserve.
        </p>
      </div>

      {/* Mobile: Grid layout, Desktop: Carousel */}
      <div className="w-full px-5">
        {/* Mobile Grid - 2 columns */}
        <div className="grid grid-cols-2 md:hidden gap-4 mb-4">
          {[...shieldPlatforms1, ...shieldPlatforms2].map((platform, index) => (
            <div
              key={index}
              className="flex justify-center items-center border border-[#EEEEEE] rounded-[10px] w-full h-20"
            >
              <img
                src={platform.icon}
                alt={platform.name}
                className="max-w-full max-h-12 object-contain"
              />
            </div>
          ))}
        </div>

        {/* Desktop Carousels */}
        <div className="hidden md:flex w-full flex-col items-center">
          <Carousel className="w-full">
            <CarouselContent className="flex nowrap w-[fit-content] mx-auto">
              {shieldPlatforms1.map((platform, index) => (
                <CarouselItem
                  key={index}
                  className="basis-1/1 md:basis-1/7 flex-shrink-0 my-12"
                >
                  <div className="flex justify-center items-center hover:scale-110 transition-transform duration-300 border border-[#EEEEEE] rounded-[10px] w-60 h-24">
                    <img
                      src={platform.icon}
                      alt={platform.name}
                      className="max-w-52 object-contain hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          <div className="-mt-[75px] w-full flex justify-center">
            <Carousel className="w-full">
              <CarouselContent className="flex nowrap w-[fit-content] mx-auto">
                {shieldPlatforms2.map((platform, index) => (
                  <CarouselItem
                    key={index}
                    className="basis-1/1 md:basis-1/7 flex-shrink-0 my-12"
                  >
                    <div className="flex justify-center items-center hover:scale-110 transition-transform duration-300 border border-[#EEEEEE] rounded-[10px] w-60 h-24">
                      <img
                        src={platform.icon}
                        alt={platform.name}
                        className="max-w-52 object-contain hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
}
